<div class="switch" role="switch">
  <input
    type="checkbox"
    name="switch06"
    [id]="'switch-' + id"
    [checked]="isChecked$ | async"
    (change)="clickHandler($event)"
    [disabled]="isDisabled$ | async"
  />
  <label [attr.for]="'switch-' + id"></label>
</div>
